var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgQrMobile = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 370,
    height: 370,
    viewBox: "0 0 370 370",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 370,
    height: 370,
    rx: 6,
    ry: 6,
    fill: "#7136ed"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 40,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 50,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 50,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 50,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 50,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 50,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 50,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 50,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 50,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 60,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 70,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 80,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 90,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 100,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 110,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 110,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 110,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 110,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 110,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 110,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 110,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 110,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 120,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 130,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 140,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 150,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 160,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 170,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 180,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 190,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 200,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 210,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 220,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 230,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 240,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 250,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 260,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 270,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 280,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 290,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 300,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 310,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 320,
    width: 10,
    height: 10,
    rx: 0,
    ry: 0,
    fill: "#ffffff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQrMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/qr-mobile.09bb7214ea5e9b6fdb38bb2ae4fd4a8c.svg";